// extracted by mini-css-extract-plugin
export default {"v-small":"(max-width: 480px)","divider":"article_page_simple_ad__divider__qGNVt"};